import React, { useCallback, useEffect, useRef, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import styles from './listing.scss';
import auditStyles from './listingHeader.scss';
import noResultStyle from '../../common/NoResultFound/no-result-found.scss';
import { getListingData, setCurrentEditPage, getVendorProducts, setTabStatus, updateApprovalPending,updateProductConflict, toggleProdConflict, updateDeletionPending, updateProductStatus, deleteProduct, deleteProductFromList, toggleConfirmDelete,toggleConfirmApprove, toggleTab, toggleInfoBox, setRedirectedFrom, getVendorImages,updateObjectionalPending,updateBrandPending, getVendorObjectionableProducts,updateBrandedProduct, updateGenericDeletionPending, updateBrand, showItemSearchSlider, updateAuditPending, updateRejectedProducts, setSearchByDocId, setShouldRetainScroll, resetListingData,filterQuery, deleteObjectionableProduct, setPreviousTabIndex } from '../../actions/products';
import { setIsUserApprovedForCatCoverage } from '../../actions/index.js' 
//import { showToastMessage } from '../../actions/toastmessage';
import ListingHeader from './ListingHeader';
import useInfiniteScroll from 'jd-library/useInfiniteScroll';
import ImageIcons from 'jd-library/ImageIcons';
import FullWidthButton from 'jd-library/FullWidthButton';
import ButtonGroup from 'jd-library/ButtonGroup';
import Modal from 'jd-library/Modal';
import Button from '../../common/Button/Button';
import ProductList from '../../common/product-list/ProductList';
import AnimateButton from '../../common/Button/AnimateButton';
import { useHistory,useParams } from 'react-router-dom';
import CSSTransition  from '../../common/transition/Animation';
import VideoListing from '../../pages/listing/VideoListing';
import AuthWrapper from '../../common/AuthWrapper';
import NoProductFound from '../../common/no-product-found/NoProductFound';
import ConfirmDelete from './ConfirmDelete';
import ConfirmModal from './confirmModal';
import { checkForCameraPermissions,identifyAuditFlow, checkLoggedIn} from '../../utills';
import { getRouteChangeMessage as getToastMessage } from '../../utills.js';
import {setSession, showHideLoader} from '../../actions/index';
import queryString from 'query-string';
import JdRepresentativeProfile from '../add-edit-product/jdRepresentativeProfile';
import JustdialCatModal from '../add-edit-product/JustdialCatModal';
import {getProductData,setSelectedType} from '../../actions/products'
import toastMessageActions from "jd-library/toastMessageActions";
import AnimateOnHover from 'jd-library/AnimateOnHover';
import axios from 'axios';
import AddPhotoProdButton from './AddPhotoProdButton';
import ObjectionalNotify from '../add-edit-product/ObjectionalNotify';
import JdCategoryCover from '../jd-category-cover/jdCategoryCover';
import UploadOptions from '../../common/upload-options/UploadOptions';
import LinkUploadSlider from '../../common/link-upload-slider/LinkUploadSlider';
import BulkUploadSlider from '../bulk-upload/BulkUploadSlider';
import ProductConflictSlider from '../product-conflict/ProductConflict';
import { togglePhotoSlider } from '../../actions/photosGallery';
import CommissionModal from './CommissionModal';
import RemoveAuditQueueSlider from './RemoveAuditQueueSlider';
import EditBrandsSlider from  '../categorySlider/EditBrandsSlider.js';
import config from '../../../config/config'
import ApproveProdModal from './ApproveProdModal';
import ActionModal from '../../common/action-modal/ActionModal';
import InventoryComplianceList from './InventoryComplianceList';
import TabInfo from './TabInfo';
import { getAllJdCatCoverData, showHideJdCatCover } from '../../actions/jdCategoryCover';
import UploadFilesView from '../add-edit-product/ViewUploadedFiles/UploadFilesView';
import BrochureListing from './BrochureListing';
import NotFound from '../../NotFound';
import { toggleFeedbackForm } from '../../common/Feature/FeedbackSlider/redux/action';
import ObjectionContentModal from '../../common/Listing/ObjectionContentModal';

const threshold = 5;

const contractorTypes = ["CONTRACTOR", "CONTRACTORV2","CONTRACTORV3"];


const Listing = props => {
	const pageNo = props.listing.currentPage;
	let products = props.listing.results;
	const productCount = products.length;
	const dispatch = useDispatch();
	const isFilterApplied = !!Object.keys(props.listing.filterObj || {}).length;
	let history = useHistory();
	let prodThreshold = (isFilterApplied || props.session.source == 'webstore' || props.tabKey  || !props.listing.allResultsFetched) ? 0 : (productCount ? 1 : 2);
	if(props.session?.viaOmni &&  props.tabKey == 'omniService'){
		prodThreshold = (productCount ? 1 : 2)
	}
	const prodListRef = useRef(null)
	// UBL iOS: toggled on scroll-settle to nudge the bottom spacer height so the
	// fixed Delete button re-settles above the footer on the last data chunk.
	const [endNudge, setEndNudge] = useState(0);
	const [showShimmer,updateShimmer] = useState(!productCount);
	const [infoBox, setInfoBox] = useState(true);
	const [showBulkUpload, setBulkUpload] = useState(false);
	const [bulkStatus, updateBulkStatus] = useState(false);
	const [commissionModal, showCommissionModal] = useState(false);
	let isAuditUrl = false;
	let showSearchAdd = false;
	const flowCheck = identifyAuditFlow({checkType: true});
	if(flowCheck.isSpecialContract){
		showSearchAdd = true;
	}
	if(flowCheck.fetchNextAudit) {
		isAuditUrl = true;
	}
	let searchByDocId = false;
	const docIdCheck = identifyAuditFlow({query: true});
	let fromSellerRejected = docIdCheck.fromSellerRejected === "true";
	let fromSellerDashboard = !!(docIdCheck.source || docIdCheck.sid);
	let allowedSources = ['1','2','3','7','14','51','52','53','57'];
	let accDetails = {
		mobile : docIdCheck.mobile,
		sid : docIdCheck.sid,
		source : docIdCheck.source,
		docid : docIdCheck.docid || props.session.docId
	};
	let showUploadLink = allowedSources.indexOf(accDetails.source) != -1;
	if(docIdCheck.searchBy == 'docId'){
		searchByDocId = true;
	}
	const isAuditor = props.session.user.loggedUser && props.session.user.loggedUser.userType == "AUDITOR" && isAuditUrl ? true : false;
	const isContractor = props.session.user.loggedUser && (contractorTypes.indexOf(props.session.user.loggedUser?.subType) != -1)
	const isObeFromSSO = props.session.user?.loggedUser?.subType == "OBE";

	useEffect(() => {
		if (!props.session.hasGlassFooter) return;
		let settleTimer = null;
		const onScroll = () => {
			if (settleTimer) clearTimeout(settleTimer);
			settleTimer = setTimeout(() => {
				if (props.listing.allResultsFetched) {
					setEndNudge(n => (n + 1) % 2);
				}
			}, 120);
		};
		window.addEventListener('scroll', onScroll, { passive: true });
		window.addEventListener('touchend', onScroll, { passive: true });
		return () => {
			window.removeEventListener('scroll', onScroll);
			window.removeEventListener('touchend', onScroll);
			if (settleTimer) clearTimeout(settleTimer);
		};
	}, [props.session.hasGlassFooter, props.listing.allResultsFetched])

	//Approve and delete product logic
	const [productShimmer, toggleProductShimmer] = useState(false);
	const [isAllChecked, setAllChecked] = useState(false);
	const isOwner = props.session.user.loggedUser && props.session.user.loggedUser.userType == "OWNER";
	const isJdRep = props.session.user.loggedUser && props.session.user.loggedUser.userType == "JDEMPLOYEE";
	const ownerPendingComps = (isOwner && (props.tabKey == 'approvalPending' || props.tabKey == 'deletionPending' || props.tabKey == 'auditPending' || props.tabKey == 'documentPending'));
	const [animateDirection, setAnimateDirection] = useState('');
	const [slideAgain, setSlideAgain] = useState('');
	const [activeTab, setActiveTab] = React.useState(0);
	const [showRepModal, toggleRepModal] = useState(false);
	const [showVendorModal, toggleVendorModal] = useState(false);
	const [showViewDetails,toggleShowViewDetails] = useState(false);
	const [justdialCatModal, showJDCatModal] = useState(false);
	const [showRequestTakeLive, toggleRequestTakeLive] = useState(false);
	const [activateDeactivateModal, toggleActivateDeactivateModal] = useState({});
	const [vendorActiveTab, setVendorActiveTab] = useState(1);
	const [brandConfirmModal, updateBrandModal] = useState(null);
	const [showAuditQueue, toggleAuditQueueSlider] = useState(false);
	const [showMaskProductsInfo, updateShowMaskProductsInfo] = useState(true);
	const [openBrandCatSlider, updateBrandCatSlider] = useState(false);
	const [showApprovalLinkModal, toggleApprovalLinkModal] = useState(false);
	const [objectionModal,updateObjectionModal] = useState({show: false,apiData: null,cb: null});
	const [openCovSlider, setOpenCovSlider] = useState(false)

	useEffect(() => {
    setTimeout(() => {
		if (props.isUserApprovedForCatCoverage && props.session.docId) {
        dispatch(getAllJdCatCoverData({ docid: props.session.docId }));
        setOpenCovSlider(true);
      }
    });
  }, [props.isUserApprovedForCatCoverage, props.session.docId]);
		

	let topPosClass = '';
	if(ownerPendingComps && (props.tabKey == 'approvalPending' || props.tabKey == 'deletionPending' || props.tabKey == 'documentPending')){
		topPosClass = infoBox ? 'with-infobox' : 'with-checkbox';
	}
	let AuditBtnArray = [];
	let AuditWebsiteBtn = [];
	let headerData = props.listing.headerData || {};
	let contractorSourceList = [];
	let jdCatList = [];
	
	const lblBasedOnTab = props.tabKey=="omniService" ? 'Service' : 'Product';
	
	const CreApprovalShowInfo = (isJdRep && props.tabKey == "approvalPending" && !isOwner);

	const attachClasses = () => {
		document.documentElement.classList.add('height100Per','overflow-hidden');
		document.body.classList.add('height100Per','overflow-auto');
	}
	const detatchClasses = () => {
		document.documentElement.classList.remove('height100Per','overflow-hidden');
		document.body.classList.remove('height100Per','overflow-auto');
	}
	const toggleActivateDeactivateModalCB = (status) =>{
		toggleActivateDeactivateModal(status);
		if(props.isMobile){
			attachClasses();
		}
	}
	if(searchByDocId){
		let firstWebsiteBtn = {}
			firstWebsiteBtn = {
				key: '1',
				label: "Company Website",
				jdWebsiteUrl:headerData.companyWebsiteLink,
				className:((headerData.companyWebsiteLink) ? '' : 'disabled')+' '+styles['hover-tooltip'],
				onClick: () => {
					headerData.companyWebsiteLink && window.open(headerData.companyWebsiteLink, "_blank");
				}
			}
		let secondWebsiteBtn = {
			key: '2',
			label: "Best Practices Website",
			jdBestPracticeWebsiteUrl:headerData.bestPracticeWebsiteLink,
			className:(headerData.bestPracticeWebsiteLink ? '' : 'disabled')+' '+styles['hover-tooltip'],
			onClick: () => {
				headerData.bestPracticeWebsiteLink && window.open(headerData.bestPracticeWebsiteLink, "_blank");
			}
		}
		AuditWebsiteBtn.push([firstWebsiteBtn,secondWebsiteBtn]);

		if(headerData.keywordList && headerData.keywordList.length) {
			AuditBtnArray.push({
				name: "Categories",
				onClick: () => {
					showJDCatModal(true);
				}
			});
			jdCatList = headerData.keywordList;
		}
		if (headerData.jdLink) {
			AuditBtnArray.push({
				name: "Justdial",
				onClick: () => {
					window.open(headerData.jdLink, "_blank");
				}
			});
		}
		if(headerData.source && headerData.source.length){
			contractorSourceList = headerData.source;
		}
	}
	const onViewClickModal = (flag) => {
		toggleShowViewDetails(flag);
		if(flag){
			document.body.classList.add('pos-fixed');
		}else{
			document.body.classList.remove('pos-fixed');
		}
	}
	const [listDataFetching, updateListDataFetch] = useState(false);
	const onTabChange = (index, prevIndex, label, filterObj) => {
		window.scroll(0,0);
		toggleProductShimmer(true);
		if(props.session.source == 'webstore'){
			setVendorActiveTab(index);
			return;
		}
		setAllChecked(false);
		props.updateProductConflict({productConflictList: []});
		props.updateApprovalPending({approvalPendingList: []});
		props.updateDeletionPending({deletionPendingList: []});
		props.updateObjectionalPending({objectionableList: []});
		props.updateAuditPending({auditPendingList: [], objectionalAuditPendingList: []});
		props.updateRejectedProducts({rejectedList: []});
		props.updateBrandPending({brandList:[]});
		props.updateGenericDeletionPending({genericDeletionList: []});
		let listingParams = {tabKey: label};
		if (filterObj){
			listingParams.filterObj = filterObj;
		}
		if(props.session.user.loggedUser && props.session.user.loggedUser.userType == 'OWNER'){
			listingParams.cb = setDefaultAllSelected;
		}
		listingParams.supplierId = props.session.supplierId;		
		props.setTabStatus({tabKey: label});
		if (index > prevIndex){
			if (animateDirection == 'slide-right')
				setSlideAgain(true);
			else
				setSlideAgain(false);
			setAnimateDirection('slide-right');
		}else if (index < prevIndex){
			if (animateDirection == 'slide-left')
				setSlideAgain(true);
			else
				setSlideAgain(false);
			setAnimateDirection('slide-left');
		}
		
		props.resetListingData();
		toggleProductShimmer(true);
		setTimeout(() => {
			setAnimateDirection('');
		}, 100)
		updateListDataFetch(true);
		setTimeout(() => {
				props.getListingData(listingParams).then((data) => {
					if(data && !props.session?.viaOmni  && data?.tabKey == 'auditPending' && data?.pageNo == '1' && data?.productData?.length < 5 && data?.totalPages > 1) {
						props.getListingData({
							tabKey: 'auditPending',
							pageNo: props.listing.currentPage + 1
						}).then(() => {
							setTimeout(() => {
								updateShimmer(false);
								toggleProductShimmer(false);
							}, 300)
						})
					}else if(!data?.message && !props.listing?.newTabClicked){
						updateListDataFetch(false);
						toggleProductShimmer(false);
					}
				}); 
		}, 300)
	}

	//By default all product are selected
	const setDefaultAllSelected = (data) => {
		let pendingListData = {};
		pendingListData[data?.tabKey + 'List'] = data?.productData.map((cur) => {
			return cur.productId;
		})
		if (data?.tabKey == 'deletionPending') {
			props.updateDeletionPending(pendingListData);
		} else if (data?.tabKey == 'approvalPending') {
			props.updateApprovalPending(pendingListData);
		}
	}

	const filterCloseCB = (filterObj) => {
		dispatch(filterQuery(filterObj))
		onTabChange(0,1, props.tabKey, filterObj);
	}

	useEffect(() => {
		console.log("listing is mounted")
		if(props?.session?.showCompanyDetails && props?.session?.autoLogin) {
			props.setSession({
				autoLogin: false
			});
		}
		if(searchByDocId){
			dispatch(setSearchByDocId({ docIdSearch: true}));
		}
	}, []);
	useEffect(() => {
		if(props.session?.viaOmni && props.listing.showShimmer){
			window.scrollTo(0,0);
		}
	},[props.listing.showShimmer])

	// useEffect(() => {
	// 	if(props.session.docId){
	// 		dispatch(getAllJdCatCoverData({docid: props.session.docId}))
	// 	}

	// },[props.session.docId])

	useEffect(() => {
		if (bulkStatus && !showBulkUpload) {
			props.getListingData({})
		}
	}, [showBulkUpload])

	const checkAll = (e) => {
		e.stopPropagation();
		let tempList = [];
		if(!isAllChecked){
			products.map((cur) => {
				tempList.push(cur.productId);
			})
		}
		let data = {};
		data[props.tabKey+'List'] = tempList;
		if(props.tabKey == 'approvalPending'){
			props.updateApprovalPending(data);
		}else if(props.tabKey == 'deletionPending'){
			props.updateDeletionPending(data);
		}
		setAllChecked(!isAllChecked);
	}

	const upBrandProdStatus = (options = {}) => {
		const { action='activate' } = options;
		const { list={}, showActive=false, showDeactive=false, activateCount=0, deactivateCount=0, changedList=[] } = props.brandSelDesel || {};
		// const singleProduct = (activateCount == 1 && deactivateCount == 0) || (activateCount == 0 && deactivateCount == 1);
		const singleProduct = (action == 'activate' && activateCount == 1) || (action == 'deactivate' && deactivateCount == 1);
		const deactivateArr=[], activateArr=[];
		for(const [key, value] of Object.entries(list)) {
			const product = props.allProducts[key];
			if(product.active) {
				deactivateArr.push(key);
			} else {
				activateArr.push(key);
			}
		}
		if(singleProduct) {
			const variantId = (action == 'activate') ? activateArr[0] : deactivateArr[0];
			const product = props.allProducts[variantId];
			updateBrandModal({
				isDeactivate: (action == 'activate') ? false : true,
				productData: product,
				productsLength: 1,
				isMultiSelect: false,
				extraData: {
					variantIds: [variantId],
					token: props.session.token,
					activate: (action == 'activate') ? true : false,
				}
			});
		} else {
			const variantIdList = (action == 'activate') ? activateArr : deactivateArr;
			updateBrandModal({
				isDeactivate: (action == 'activate') ? false : true,
				productsLength: (action == 'activate') ? activateCount : deactivateCount,
				isMultiSelect: true,
				extraData: {
					variantIds: variantIdList,
					token: props.session.token,
					activate: (action == 'activate') ? true : false,
				}
			});
		}
	}

	const checkForCommission = (cb) => {
		let hasCommission = false;
		props.approvalPendingList.map((id)=>{
			if(props.allProducts[id].commissionPerc){
				hasCommission = true;
			}
		})
		if(hasCommission){
			showCommissionModal(true)
		}else{
			updateProductStatus('approve', null,cb);
		}
	}

	const updateProductStatus = (action = 'approve', isDelete,updateCallBack) => {
		if(action == 'delete' && isDelete){
			let isMulti = props.deletionPendingList.length > 1 || (props.auditPendingList.length + props.objectionalAuditPendingList.length) > 1 || props.rejectedList.length > 1 ? true : false;
			let productDetails = props.allProducts[props.tabKey == 'auditPending' ? props.auditPendingList[0] : props.tabKey == 'rejected' ? props.rejectedList[0] : props.deletionPendingList[0]];
			if(props.session.source == 'webstore'){
				Object.keys(props.allProducts).map((cur, index) => {
					if(props.allProducts[cur].productId == props.deletionPendingList[0]){
						productDetails = props.allProducts[cur];
					}
				})
			}
			confirmDelete(productDetails, isMulti);
			return;
		}
		const pidListData =props.approvalPendingList.map((data,i)=>{
			return(props.allProducts[data].pidList)
		})
		let productLength = action == 'approve' ? props.approvalPendingList.length : props.deletionPendingList.length;
		let productIds = action == 'approve' ? pidListData.toString() : props.deletionPendingList.toString()
		let toastMessage = productLength + ` ${props.session.profileObject.PluralLabelWithSpace} Approved Successfully`;
		if (action == 'delete') {
			toastMessage = productLength + ` ${props.session.profileObject.PluralLabelWithSpace} Deleted Successfully`;
		}
		if(productLength == 1){
			if(action == 'approve'){
				toastMessage = (props.allProducts[props.approvalPendingList[0]].type == 'service' ? 'Service' : 'Product') + ' Approved - ' + props.allProducts[props.approvalPendingList[0]].productName;
			}else if(action == 'delete' && isDelete){
				toastMessage = (props.allProducts[props.deletionPendingList[0]]?.type == 'service' ? 'Service' : 'Product') + ' Deleted - ' + props.allProducts[props.deletionPendingList[0]]?.productName;
			}
		}
		props.showHideLoader({
			showLoader: true
		});
		props.updateProductStatus({
			token: props.session.token,
			productId: productIds,
			action: action,
			isDelete: isDelete,
			isAllSelected: isAllChecked,
			cb: (isLastProductApproved = false, res = {}) => {
				if(action == 'approve'){
					props.updateApprovalPending({approvalPendingList: []});
				}else{
					props.updateDeletionPending({deletionPendingList: []});
					props.updateGenericDeletionPending({genericDeletionList: []});
				}
				setAllChecked(false);
				props.getListingData({tabKey: props.tabKey,cb: () => {
					updateCallBack && updateCallBack();
					props.showHideLoader({
						showLoader: false
					});
				}});
				if(action == 'approve' || (action == 'delete' && isDelete)){
					dispatch(toastMessageActions.showMessage({
						message: toastMessage,
						showReduxToast: true,
						animationTime :5000,
						bottom: props.session.hasGlassFooter ? '80px' : '0px',
					}))
					if(res.objectionableCount) {
						updateObjectionModal({
							show: true,
							apiData: res,
							isLastProductApproved,
							cb: (isLastProductApproved = false) => {
								if(props.session?.user?.loggedUser?.userType == 'OWNER' && action == 'approve' && isLastProductApproved)
									dispatch(toggleFeedbackForm({show:true,options: {isObjectionable: true}}));
							}
						})
					}
				}
				if(props.session?.user?.loggedUser?.userType == 'OWNER' && action == 'approve' && isLastProductApproved) {
					dispatch(toggleFeedbackForm(true));
				}
				if (action=='delete' && !isDelete) {
					props.showHideLoader({
						showLoader: false
					});
				}
			}
		})
	}

	useEffect(() => {
		if(((props.tabKey == 'approvalPending' && props.approvalPendingList.length == props.listing.results.length) || (props.tabKey == 'deletionPending' && props.deletionPendingList.length == props.listing.results.length)) && props.listing.results.length){
			setAllChecked(true);
		}else{
			setAllChecked(false);
		}
	}, [props.approvalPendingList, props.deletionPendingList, props.listing.results, props.tabKey])

	//Multiple deletion
	const [productData, setProductData] = useState({});
	const [isMultiSelect, setMultiSelect] = useState(false);
    const [bottomLoader, updateBottomLoader] = useState(false);
	const confirmDelete = (productData, isMultiSelectFlag) => {
		setMultiSelect(isMultiSelectFlag);
		setProductData(productData);
		props.toggleConfirmDelete({confirmDeleteModal: true});
	}
	const confirmApprove = () => {
		props.toggleConfirmApprove({confirmApproveModal: true});
	}
	const deleteProduct = () => {
		if ((isAuditor && productData?.isObjectionable) || productData?.objectionableContent || props.tabKey ==  "objectionable") {
			props.deleteObjectionableProduct({
				id: productData.id,
				cb: () => {
					showHideLoader(false);
				}
			});
			let toastMessage = `${productData.type == 'service' ? 'Service' : 'Product'} Deleted Successfully`;
			dispatch(toastMessageActions.showMessage({
				message: toastMessage,
				type: 'info',
				showReduxToast: true,
				animationTime :5000,
				bottom: props.session.hasGlassFooter ? '80px' : '0px',
			}))
		} else {
			if(vendorActiveTab == 2){
				let productId = "";
				if(isMultiSelect){
					productId = props.deletionPendingList.join(",");
				}else if(props.deletionPendingList.length){
					productId = props.deletionPendingList[0];
				}else{
					productId = productData.id;
				}
				window.history.back(); //Close Modal
				axios.get('/marketplace/static/php/web/b2bWebsite.php?action=deleteObjectionableProduct&id='+productId)
				.then((res)=>{
					if(res.data.status == 1){
						dispatch(toastMessageActions.showMessage({
							message: 'Product Deleted',
							showReduxToast: true,
							animationTime :5000,
							bottom: props.session.hasGlassFooter ? '80px' : '0px',
						}))
						props.getVendorObjectionableProducts(1).then((res)=>{
							if(res == 0){
								setVendorActiveTab(1);
							}
						});
					}
				})
				return;
			}
			if(productData?.cb){
				productData.cb();
			}else{
				let productToDelete = props.session.source == 'webstore' ? productData.productId.toString() : productData?.pidList ? productData.pidList : productData?.productId;
				let toastMessage = `${productData?.type == 'service' ? 'Service' : 'Product'} Deleted Successfully`;
				let deletionIds = props.tabKey == 'auditPending' ? [...props.auditPendingList] : props.tabKey == 'rejected' ? [...props.rejectedList] : [...props.deletionPendingList];
				let deletionObjectionalIds = props.tabKey == 'auditPending' ? [...props.objectionalAuditPendingList] : [];
				let genericDeletionIds = [...props.genericDeletionList];
				if(!isMultiSelect && genericDeletionIds.length){
					productToDelete = '';
				}
				if(isMultiSelect){
					deletionIds = deletionIds.filter((cur) => {
						if(genericDeletionIds.indexOf(cur) == -1){
							return cur;
						}
					})
					productToDelete = deletionIds.toString();
					toastMessage = `${props.tabKey == 'auditPending' ? (props.auditPendingList.length + props.objectionalAuditPendingList.length) : props.tabKey == 'rejected' ? props.rejectedList.length : props.deletionPendingList.length} Item(s) Deleted Successfully`;
				}
				if(props.session.source == 'webstore'){
					let variantArr = isMultiSelect ? Object.keys(props.allProducts).filter((cur, index) => {
						return props.deletionPendingList.indexOf(props.allProducts[cur].productId) > -1;
					}) : [productData.variantId];
					props.deleteProduct(productToDelete, () => {
						variantArr.map((eachVariant, index) => {
							props.deleteProductFromList(eachVariant)
						})
					}, productToDelete);
				}else{
					props.showHideLoader({
						showLoader: true
					});
					props.deleteProduct(productToDelete,null,null,{
						generic_p_id : genericDeletionIds.toString(),
						objectional_ids: deletionObjectionalIds.toString(),
						cb: () => {
							props.showHideLoader({
								showLoader: false
							})
							dispatch(toastMessageActions.showMessage({
								message: toastMessage,
								type: 'info',
								showReduxToast: true,
								animationTime :5000,
								bottom: props.session.hasGlassFooter ? '80px' : '0px',
							}))
						}
					});
				}
				setTimeout(() => {
					props.updateDeletionPending({deletionPendingList: []});
					if(props.tabKey == 'auditPending'){
						props.updateAuditPending({auditPendingList: [], objectionalAuditPendingList: []});
					}else if(props.tabKey == 'rejected'){
						props.updateRejectedProducts({rejectedList: []});
					}
					props.updateGenericDeletionPending({genericDeletionList: []});
				}, 300);
			}
		}
		window.history.back();
	}

	const onDeleteModalClose = () => {
		props.toggleConfirmDelete({confirmDeleteModal: false});
	}

	const onApproveClose = () => {
		props.toggleConfirmApprove({confirmApproveModal: false});
	}



	useEffect(() => {
		if(showShimmer && props.session.isAppInitialized){
			let data = {};
			if(props.tabKey){
				data.tabKey = props.tabKey;
			}
		}
	},[props.session.isAppInitialized])

	useEffect(()=>{
		if(props.session.source == 'webstore'){
			props.getVendorProducts({})
		}
	},[props.selectedOutlet])

	const setCookie = (name, value) => {
		var date = new Date();
		date.setTime(date.getTime() + (24 * 60 * 60 * 365));
		document.cookie = name + '=' + value + ';expires=' + date.toUTCString();
	}

	const getCookie = (name) => {
		if (!document.cookie.includes(name)) {
			return '';
		}
		let temp = document.cookie.split(name + '=')[1];
		return temp.split(';')[0]
	}
	const [listingOnLoad, updateListingOnLoad] = useState(false);
	useEffect(() => {
		// if (props.session.user.loggedUser && (props.isToggleTab || (window.location.search.indexOf('token=') != -1 && sessionStorage && !sessionStorage.getItem("isTabToggled"))) && ((props.listing.approvalPendingCount && props.listing.approvalPendingCount != "0") || (props.listing.deletionPendingCount && props.listing.deletionPendingCount != "0"))) {
		// 	// updateShimmer(true);
		// 	let data = {}, activeTabToSet = 0;
		// 	if (props.session.user.loggedUser.userType == 'OWNER') {
		// 		if (props.listing.approvalPendingCount != "0") {
		// 			data.tabKey = 'approvalPending';
		// 			activeTabToSet = 1;
		// 		} else if (props.listing.deletionPendingCount != "0") {
		// 			data.tabKey = 'deletionPending';
		// 			activeTabToSet = 2;
		// 		}
		// 	}
		// 	if(props.session.user.loggedUser.userType == "JDEMPLOYEE" && getCookie("repModal") != 'true' && props.listing.results.length){
		// 		toggleRepModal(true);
		// 		setCookie("repModal", true);
		// 		return;
		// 	}
		// 	props.getListingData(data).then(() => {
		// 		setActiveTab(activeTabToSet);
		// 		props.setTabStatus({tabKey: data.tabKey});
		// 		setTimeout(() => {
		// 			updateShimmer(false);
		// 		}, 300)
		// 		if (props.session.user.loggedUser.userType == 'OWNER' && getCookie("vendorModal") != 'true' && (props.listing.approvalPendingCount != "0" || props.listing.deletionPendingCount != "0")) {
		// 			toggleVendorModal(true);
		// 			setCookie("vendorModal", true);
		// 		} else if (props.session.user.loggedUser.userType == "JDEMPLOYEE" && getCookie("repModal") != 'true') {
		// 			toggleRepModal(true);
		// 			setCookie("repModal", true);
		// 		}
		// 		props.toggleTab({isToggleTab: false})
		// 		if(window.location.search.indexOf('token=') != -1){
		// 			sessionStorage && sessionStorage.setItem('isTabToggled', true);
		// 		}
		// 	});
		// } else {
		// 	if(props.session.user.loggedUser && props.session.user.loggedUser.userType == "JDEMPLOYEE" && getCookie("repModal") != 'true'){
		// 		toggleRepModal(true);
		// 		setCookie("repModal", true);
		// 	}
		// 	let data = {};
		// 	if(props.tabKey){
		// 		data.tabKey = props.tabKey;
		// 	}
		// 	if (props.session.source == 'b2b' && !props.listing.results.length) {
		// 		props.getListingData(data).then(() => {
		// 			if (props.tabKey) {
		// 				if ((props.tabKey == 'approvalPending' && props.listing.approvalPendingCount == "0") || (props.tabKey == 'deletionPending' && props.listing.deletionPendingCount == "0")) {
		// 					props.setTabStatus({ tabKey: undefined });
		// 					updateShimmer(true);
		// 					props.getListingData({}).then(() => {
		// 						updateShimmer(false);
		// 					})
		// 				} else {
		// 					updateShimmer(false);
		// 				}
		// 			} else {
		// 				updateShimmer(false);
		// 			}
		// 		});
		// 	}
		if (props.session.source == 'b2b' && props.session.supplierId && (!props.shouldRetain)) {
			toggleProductShimmer(true)
			props.getListingData({
				tabKey:props.tabKey,
				supplierId: props.session.supplierId,
				filterObj : props.filterProductObj,
				isReadOnly: props.session.isReadOnly  ? true : false,
				cb: (result) => {
					toggleProductShimmer(false)
					const isGenioUrl = props.session.showCompanyDetails;
					const toggleTabKey = `isTabToggled`;
					const switchTabs = !isGenioUrl && sessionStorage && !sessionStorage.getItem(toggleTabKey);
					if(fromSellerRejected){
						let data = {};
						data.tabKey = 'rejected';
						data.supplierId = props.session.supplierId;
						props.getListingData(data).then(() => {
							props.tabKey != "brochure" && props.setTabStatus({ tabKey: data.tabKey });
							setTimeout(() => {
								updateShimmer(false);
							}, 300)
							props.toggleTab({ isToggleTab: false })
							if (window.location.search.indexOf('token=') != -1 || switchTabs) {
								sessionStorage && sessionStorage.setItem('isTabToggled', true);
							}
							updateListingOnLoad(true);
						});
					}else{
						if (props.session.user.loggedUser && result && (props.isToggleTab || switchTabs || (window.location.search.indexOf('token=') != -1 && sessionStorage && !sessionStorage.getItem("isTabToggled")))) {
							let data = {}, activeTabToSet = 0;
							const brandedCount = result.suggestedProductsCount || 0;
							if (!props.session?.viaOmni && (props.session.user.loggedUser.userType == 'OWNER' && ((brandedCount && brandedCount != 0) || (result.approvalPendingCount && result.approvalPendingCount != "0") || (result.deletionPendingCount && result.deletionPendingCount != "0")))) {
								if (!props.pauseApprovalRedirect && result.approvalPendingCount != "0") {
									data.tabKey = 'approvalPending';
									let activeTab = 1;
									if(brandedCount) {
										activeTab =  3;
									}else {
										activeTab = 2;
									}
									activeTabToSet = activeTab;
								} else if (result.deletionPendingCount != "0") {
									data.tabKey = 'deletionPending';
									activeTabToSet = brandedCount ? 3 : 2; // Aarvi Industrial Materials issue
								}
								if(!result.productData.length && props.session?.user?.loggedUser?.userType == 'OWNER' && brandedCount) {
									data.tabKey = 'brand';
									data.supplierId = props.session.supplierId;
									activeTabToSet = 2;
								}
								setActiveTab(activeTabToSet);
								props.setPreviousTabIndex({tabIndex: activeTabToSet});
								props.setTabStatus({ tabKey: data.tabKey });
								data.cb = setDefaultAllSelected;
								props.getListingData(data).then(() => {
									setActiveTab(activeTabToSet);
									props.tabKey != "brochure" && props.setTabStatus({ tabKey: data.tabKey });
									setTimeout(() => {
										updateShimmer(false);
										toggleProductShimmer(() => false);
									}, 300)
									props.toggleTab({ isToggleTab: false })
									if (window.location.search.indexOf('token=') != -1 || switchTabs) {
										sessionStorage && sessionStorage.setItem('isTabToggled', true);
									}
									updateListingOnLoad(true);
								});
							} else if (props.session.user.loggedUser.userType == "JDEMPLOYEE" && getCookie("repModal") != 'true' && result.productData.length) {
								updateShimmer(false);
								toggleRepModal(true);
								setCookie("repModal", true);
								updateListingOnLoad(true);
								return;
							} else {
								updateShimmer(false);
								updateListingOnLoad(true);
							}
						} else {
							updateShimmer(false);
							updateListingOnLoad(true);
						}
					}
				}
			})
		} else {
			// props.getVendorProducts({
			// 	filterObj: props.listing.filterObj || {}
			// }).then(() => {
			// 	updateShimmer(false);
			// });
			// props.getVendorObjectionableProducts().then(()=>{
			// 	if(props.redirectedFrom == 'objectionable-modal'){
			// 		setVendorActiveTab(2);
			// 		props.setRedirectedFrom('');
			// 	}
			// });
		}
		if(props.shouldRetain){
			props.setShouldRetainScroll(false);
			updateListingOnLoad(true);
		}
		// }
	}, [props.session.supplierId, props.pauseApprovalRedirect]);

	useEffect(() => {
		// Fetch VEndor Images
		if(props.session.supplierId){
			props.getVendorImages({supplierId: props.session.supplierId})
			if(props.session?.user?.loggedUser?.userType == 'OWNER') {
				var deviceSource = props.session.userSource;
				axios.get('/marketplace/webstore/collect-data.ns?li=impressions_hot_leads&ll=digital_catalogue&device_src='+deviceSource+'&device_id=Omni_Marketplace&doc_id='+props.session.docId).then(res => {
					if(res.data.isSuccess)
						console.log('click tracked successfully')
				}).catch(err => {
					console.log('Error in ClickTracker => ',err)
				})
			}
		}
	}, [props.session.supplierId])

	const loadDataOnInfiniteScroll = () => {
		if(productShimmer){
			setIsFetching(false);
			return;
		}
		if(!listingOnLoad && props.session.source == 'b2b') {
			setIsFetching(false);
			return;
		}
		if (props.listing.allResultsFetched) {
			setIsFetching(false);
			return;
		}
		const pageNo = props.listing.currentPage + 1;
		if (props.session.source == 'webstore') {
			if(vendorActiveTab == 2){
				if(props.objectionableProducts.length % 25 == 0){
					//Possible there are more products
					console.log("Fetching More Objectionable");
					let curPage = props.objectionableProducts.length/25;
					props.getVendorObjectionableProducts(curPage + 1).then(()=>{
						console.log("Products Fetched");
						setIsFetching(false);
						return;
					});
				}else{
					console.log("End of products");
					setIsFetching(false);
					return;
				}
			}
			props.getVendorProducts({
				pageNo,
				filterObj: props.listing.filterObj
			}).then(() => {
				setIsFetching(false);
			});
		}else{
			if(isAuditor && isAuditUrl) {
				updateBottomLoader(true);
			}
			props
				.getListingData({
					pageNo,
					filterObj: props.listing.filterObj,
					tabKey: props.tabKey,
					supplierId: props.session.supplierId,
					cb: (rsp) => {
						if(isAllChecked && props.tabKey == 'approvalPending') {
							props.updateApprovalPending({
								approvalPendingList: [...props.approvalPendingList, ...rsp.productData.map((cur) => cur.productId)]
							})
						}
					}
				})
				.then(res => {
					if(isAuditor && isAuditUrl) {
						updateBottomLoader(false);
					}
					setIsFetching(false);
				});
		}
	};
	/*useEffect(() => {
		const firsAddProd = prodListRef.current && prodListRef.current.querySelector(".add-prod-block")
		if(firsAddProd){
			const firsAddProd = prodListRef.current.querySelector(".add-prod-block")
			const maxBlock = (window.outerHeight - firsAddProd.getBoundingClientRect().top) / firsAddProd.offsetHeight;
			updateThreshold(Math.round(maxBlock) + productCount);
		}

	},[productCount,showShimmer]);*/

	const [isFetching, setIsFetching] = useInfiniteScroll({
		loadMoreCB: loadDataOnInfiniteScroll,
		threshold: 300,
		useWindow: true
	});

	const receiveMessage = (event) => {
		let data = (typeof event.data == 'string') ? JSON.parse(event.data) : {};
		if(data.msg == "productSaved" || data.msg == "close"){
			props.getVendorProducts({});
		}
	}
	const redirectToAddProduct = (selectedProductType = '') => {
		if(props.session.source == 'webstore'){
			// ProductIframeCommunication.open({
			// 	appType: "vendorApp",
			// 	pageType: "add",
			// 	module: 'product'
			// });
			// return;
			axios({
				method :'GET',
				url : '/marketplace/static/php/web/walkThroughApi.php?action=getStatus'
			}).then((res) => {
				if(res && res.data && res.data.isShopVirtual) {
					location.href = `/myaccount/vendor/update-product-walkthrough`;
				}
				else {
					history.push('/add-item');
					props.setRedirectedFrom({redirectedFrom: 'listing'});
				}
			})
			return;
		}
		if(isAuditor){
			let data = window.location.search;
			let search = queryString.parse(data);
			if(data){
				data+="&selectedProductType="+selectedProductType;
			}
			if(search.actualToken && search.actualToken != props.session.token) {
				window.location.href = `/vendor/manage-products-genio/${search.actualToken}/products/add${data}`;
			} else {
				history.push('/products/add'+data);
			}
		}else{
			if (props.isMobile){
				props.showItemSearchSlider(selectedProductType)
				if (selectedProductType == 'product'){
					history.push('/products/itemsearch');
				}else {
					props.setSelectedType({
						selectedCategoryType: selectedProductType
					});
					let addUrlPrefix = props.session?.viaOmni?"/products/add-omni":"/products/add"
					if(!props.session?.hideSuggestedAutoServiceSlider && !props.session?.viaOmni){
						addUrlPrefix = '/products/itemsearch';
					}
					history.push(`${addUrlPrefix}?selectedProductType=`+selectedProductType);
				}
			}else{
				if(selectedProductType == 'product'){
					props.showItemSearchSlider(selectedProductType)
				}else {
					props.setSelectedType({
						selectedCategoryType: selectedProductType
					});
					if (!props.session?.hideSuggestedAutoServiceSlider ){
						props.showItemSearchSlider(selectedProductType)
					}else {
						props.getProductData({
						productId : 'ADD_PRODUCT'
					})
					}
				}
			}
		}

		//history.push('/products/auth');
	};

	const redirectToBrandsCatSlider = (isOpen) => {
		updateBrandCatSlider(isOpen)
		if(props.isMobile){
			history.push('/edit-brand');
		}
	}
	const redirectToJdPhotos = () => {
		// if(props.isMobile) {
		// 	history.push('/products/jd-photos')
		// } else {
			props.togglePhotoSlider({
				isJdPhotoSlider: true,
				selectPhotoSlider: true,
			})
		// }
	}
	const removeFilters = () => {
		if (props.session.source == 'webstore') {
			props.getVendorProducts({});
		} else {
			props.setTabStatus({tabKey: undefined})
			dispatch(filterQuery(''))
			props.getListingData({

			}).then(rsp => {
				toggleProductShimmer(false)
			})
		}
	};

	const clickHandler = () => {
		if (isFilterApplied) {
			toggleProductShimmer(true)
			return removeFilters();
		}
		redirectToAddProduct(props.session?.viaOmni && lblBasedOnTab.toLowerCase()=='service' ? 'service' : '');
	};

	const closeInfoBox = () => {
		setInfoBox(false);
		props.toggleInfoBox({showInfoBox: false});
	}

	const handleCloseModal =()=>{
        toggleApprovalLinkModal(false);
    }

	const handleShowJdCatCover = ()=>{
		dispatch(showHideJdCatCover(false));
		setOpenCovSlider(false)
		dispatch(setIsUserApprovedForCatCoverage(false));
	}
	
	const getSubSourceBasedOnUser = () => {
		return props.session.isOnboardingEmp ? `onboarding_AL` :
		props.session.user.loggedUser?.subType=="CONTRACTOR" ? `contractorv1_AL` :
		props.session.user.loggedUser?.subType=="CONTRACTORV2" ? `contractorv2_AL` :
		props.session.user.loggedUser?.subType=="OBE" ? `jdemployee_AL` :
		props.session.user.loggedUser.userType == "JDEMPLOYEE" ? `jdemployee_AL` :
		props.session.subSource;
		
	}

	const onConfirmApprovalLink=()=>{
        toggleApprovalLinkModal(false);
		let url = `/marketplace/static/php/web/b2bWebsite.php?&action=sendOwnerApprovalMsg&token=${props.session.token}&source=${props.session.user.loggedUser.userType == 'OWNER' ? props.session.userSource : `digital_catalog`}&subsource=${getSubSourceBasedOnUser()}&creApproval=1`
		axios.get(url)
        .then(({ data }) => {
            if(data.success){
				dispatch(toastMessageActions.showMessage({
                    message: 'Catalogue Approval Link Sent',
                    type: 'info',
                    showReduxToast: true,
                    duration: 4000,
					bottom: props.session.hasGlassFooter ? '80px' : '0px',
                }))
                // historyHandler.closeAll();
            }else {
				dispatch(toastMessageActions.showMessage({
                    message: data.msg || '',
                    type: 'info',
                    showReduxToast: true,
                    duration: 4000,
					bottom: props.session.hasGlassFooter ? '80px' : '0px',
                }))
			}
        })
	}

	useEffect(() => {
		props.setCurrentEditPage('listing');
		/*if (accDetails?.source!=21) {
			checkForCameraPermissions();	
		}
		*/		
		let toastmsg = getToastMessage();
		if(toastmsg){
			dispatch(toastMessageActions.showMessage({
				message: toastmsg.message,
				showReduxToast: true,
				animationTime :5000,
				bottom: props.session.hasGlassFooter ? '80px' : '0px',
			}))
		}
	}, []);

	const isUnauthorized = props.session.isUnauthorized;


	const filterNoResult = {
		imgSrc: ImageIcons.EMPTY_PRODUCT,
			// 'https://image1.jdomni.in/jdomni_email/NoProductFound_1911281253.png',
		title: 'No Results Found',
		subTitle: 'No results found as per your filter selection',
		button: {
			text: 'Remove Filters'
		}
	};

	const noProductResult = {
		imgSrc: ImageIcons.EMPTY_PRODUCT,
		// 'https://image1.jdomni.in/jdomni_email/onlyProductJd_1912022056.png',
		title: 'Showcase Your '+lblBasedOnTab+'s',
		subTitle: 'Add '+lblBasedOnTab.toLowerCase()+'s and grab attention of your customers',
		className: 'no-product-container',
		button: {
			text: 'Add New '+lblBasedOnTab,
			showPlusIcon: false,
			className: 'btn-add'
		}
	};

	const unautorizedObj = {
		className : 'unautorized-page',
		imgSrc: 'https://image1.jdomni.in/jdomni_email/01_2001071837.png',
		title: 'Unauthorized Access',
		subTitle: 'Sorry, you are not authorized to access this page'
	};
	const shimmmerArr = Array(showShimmer ? 10 : 0).fill(1);
	if(props.session.notAuthorised) {
		return <NotFound />;
	}else if(shimmmerArr.length){
		return (
			<div className='shimmer-container'>
				<div className='upload-label'>
					<div className='head-title shimmer-loader' />
				</div>
				<div className='prod-list'>
					{shimmmerArr.map((_,index) => {
						return (
							<div className='prod-block' key={index}>
								<div className='img-holder shimmer-loader' />
								<div className='prod-desc'>
									<p className='prod-title shimmer-loader' />
									<p className='min-order-qty shimmer-loader' />
									<div className='price shimmer-loader' />
								</div>
								<div className='fake-border' />
							</div>
						);
					})}

				</div>
			</div>
		);
	}
	const noResultDataObj = (isUnauthorized && !isAuditor) ? unautorizedObj : isFilterApplied && !productShimmer ? filterNoResult : (!['approvalPending','deletionPending'].includes(props.tabKey)) && props.listing.gotResponse ? noProductResult : null;
	const fakeAddBox = prodThreshold;//prodThreshold - productCount
	if(!isUnauthorized){
		const fakeProducts = [];
		fakeProducts[fakeAddBox - 1] = null;
		if(!isAuditor){
			fakeProducts.fill({ productId: 'ADD_PRODUCT',isDummyProductRow : true });
			products = [
				...products,
				...fakeProducts
			]
		}else{
			products = [
				...products
			]
		}
	}
	const noProductPresent = !products.length && props.tabKey !== 'brochure';
	if(products.length ) {
		products = products.filter(cur => (cur.productId != 'ADD_PRODUCT'));
	}
	const sliderCloseCB = () => {
		if(props.session.source == 'b2b'){
			props.getListingData({tabKey: props.tabKey});
		}
	}
	let infoText = '';
	let noProductLabel = undefined;
	if (props.tabKey == 'approvalPending'){
		if(CreApprovalShowInfo){
			infoText =( <div className={`${styles['approval-btn-holder']} ${props.isMobile ? 'mobile' : ''}`}>
				<span className="mgr-10 font-12">Send Catalogue Approval Link</span>
				<Button
					className={`${styles['send-approval-tab-btn']} ${props.isMobile ? 'mobile' : ''} `}
					size='xs'
					clickHandler={() => {
						// history.push('/products/auth');
						toggleApprovalLinkModal(true)
					}}
				>
					{<span>SEND LINK</span>}
				</Button>
			</div> )
		}else{
			infoText = 'Justdial Representative has made some changes in the following products which requires your approval to go live';
			noProductLabel = `All ${props?.session?.profileObject?.PluralLabelWithSpace} have been Approved`;
		}
	}
	else if (props.tabKey == 'deletionPending'){
		infoText = 'Justdial representative has marked some products for deletion which require your confirmation';
		noProductLabel = `No ${props?.session?.profileObject?.PluralLabelWithSpace} are Awaiting Deletion`;
	}else if(props.tabKey == 'objectionable'){
		noProductLabel = `No Objectionable ${props?.session?.profileObject?.PluralLabelWithSpace}`;
	}else if(props.tabKey == 'auditPending'){
		infoText = 'Please note that your product will be audited before it goes live on the marketplace';
		noProductLabel = `No ${props?.session?.profileObject?.PluralLabelWithSpace} are in audit pending`
	}else if(props.tabKey == 'brand' ){
		noProductLabel = `No Suggested ${props?.session?.profileObject?.PluralLabelWithSpace}`;
	}else if(props.tabKey == 'productConflict'){
		noProductLabel = `No Barcode Conflict ${props?.session?.profileObject?.SingleLabelWithSpace} Found`
	}else if(props.tabKey == 'documentPending' && isOwner){
		/*
		let completeUrl = `${config.dcBizDomainUrl}/seller-dashboard/uploadocuments?source=${accDetails.source || ''}&docid=${accDetails.docid}&action=back`;
		if(accDetails.source == '14'){
			completeUrl += `&token=${props.session.token}`;
		}
		*/
		infoText =( <div>
			Some products have been rejected due to pending document upload.
			
			{!props.session.isReadOnly && props?.listing?.documentUploadLink && (props?.session?.user?.loggedUser?.userType == 'OWNER') ? (<a target={'_blank'} className={`upload-document-link`} href={props.listing.documentUploadLink}>Click here to upload the required Document(s)</a>) : null}			
		</div> )
	}else if (props?.user?.loggedUser?.userType == "AUDITOR" && !products.length){
		noProductLabel = `No ${props?.session?.profileObject?.SingleLabelWithSpace} Found`
	}


	let {reduxSessionInit, loggedUser, noUserCheck} = props.session.user || {};
	const showLoginBtn = reduxSessionInit && !loggedUser && !noUserCheck && props.session.showCompanyDetails && !isUnauthorized && !(!props.tabKey && props.deletionPendingList.length) && !props.session.isReadOnly;
	if(showLoginBtn && props.session.viaOmni && reduxSessionInit) {
		setTimeout(() => {
			window.location.href = `${window.location.origin}/myaccount`;
		}, 100);
		return null;
	}
	let showDeleteBtn = false;
	if(props.session.source == 'webstore'){
		showDeleteBtn = (props.deletionPendingList.length && (vendorActiveTab == 1)) ? true : false;
	}else{
		showDeleteBtn = (!props.tabKey && props.deletionPendingList.length) || (props.tabKey=="omniService" && props.deletionPendingList.length) || (props.tabKey == 'auditPending' && (props.auditPendingList.length || props.objectionalAuditPendingList.length)) || (props.tabKey == 'rejected' && props.rejectedList.length) ? true : false;
	}
	let maskProductMailId = "jdmart_feedback@justdial.com";
	let MaskProductsInfo = (
		<div className='maskinfo-box'>
			Few category mismatches were noticed in your contract. Products in this digital catalogue will go live post review. Write to us at <span className='mail-info'><a href={`mailto:${maskProductMailId}`}>{`${maskProductMailId}`}</a> </span> for any queries
			<span className='cross-icon'>
				<i className='icon-HDRcross' onClick={() => {
					updateShowMaskProductsInfo(false);
				}}></i>
			</span>
		</div>
	)
	const profileType = props.session.profileObject.SingleLabelWithSpace

	return (
		<div className={`${styles['listing-page']} ${props.tabKey ? styles['has-tab'] : ''}`}>
			{isUnauthorized && !isAuditor ? null : 
			<ListingHeader 
				{...props} 
				onTabChange={onTabChange} 
				filterCloseCB={filterCloseCB} 
				isAuditor={isAuditor} 
				activeTab={activeTab} 
				showSearchAdd = {showSearchAdd} 
				onViewDetailsClick = {onViewClickModal} 
				showVendorTabs={false} 
				activeVendorTab={vendorActiveTab} 
				toggleAuditQueueSlider = {toggleAuditQueueSlider}
			/> }
			<CSSTransition>
				<>
					{(props.showInfoBox && infoBox && products.length && (CreApprovalShowInfo || ownerPendingComps) ) ? (
						<div className={`rep-info-box ${props.tabKey == 'documentPending' ? 'document-pending-box' : ''}`}>
						{props.tabKey != 'documentPending' ?
						<>
							{!CreApprovalShowInfo?<div className='icon-div'>
								<i className='icon-Info'></i>
							</div>:null}
							<div className={`info-text ${CreApprovalShowInfo ? `cre-approval-show-info ml-5 ${props.isMobile ? 'mobile' : ''}` : ''}`}>
								<div>{infoText}</div>
								{props.tabKey == 'auditPending' || CreApprovalShowInfo ? null : <div>In case of any query, you can contact the following Account Manager</div>}
								{props.tabKey == 'auditPending' || CreApprovalShowInfo ? null : <div className='rep-data'>
									<div className={styles['rep-name']}>
										<i className='icon-profile'></i>
										<span>{props.session?.user?.loginData?.employeeName}</span>
									</div>
									{props.session?.user?.loginData?.employeeMobileList?.length > 0 &&
										<div className={styles['rep-number']}>
										<i className='icon-HDRcall'></i>
										<span>{props.session.user.loginData.employeeMobileList[0]}</span>
									</div>}
									{props.session?.user?.loginData?.employeeEmailList?.length > 0 &&
										<div className={styles['rep-mail']}>
											<i className='icon-mailLg'></i>
											<span>{props.session.user.loginData.employeeEmailList[0]}</span>
										</div>
									}
								</div>}

							</div>
							{props.tabKey == 'auditPending' || CreApprovalShowInfo ? null : <div className='cross-icon'>
								<i className='icon-HDRcross' onClick={closeInfoBox}></i>
							</div>}
						</> : <TabInfo infoText={infoText} isSubtext={true}/>  }
						</div>
					) : null}

					{(false) ? (
						<div className={`rep-info-box ${props.tabKey == 'documentPending' ? 'document-pending-box' : ''}`}>
						{props.tabKey != 'documentPending' ?
						<>
							{!CreApprovalShowInfo?<div className='icon-div'>
								<i className='icon-Info'></i>
								<div className={`info-text-doc-penging`}>Document Upload Pending</div>
								<span>Some products have been rejected due to pending document upload.</span>
							</div>:null}
							<div className={`info-text ${CreApprovalShowInfo ? `cre-approval-show-info ml-5 ${props.isMobile ? 'mobile' : ''}` : ''}`}>
								
								{/* <div>{infoText}</div> */}
								{/* {props.tabKey == 'auditPending' || CreApprovalShowInfo ? null : <div>In case of any query, you can contact the following Account Manager</div>} */}
								{props.tabKey == 'auditPending' || CreApprovalShowInfo ? null : <div className='rep-data'>
									{/* <div className={styles['rep-name']}>
										<i className='icon-profile'></i>
										<span>{props.session.user.loginData.employeeName}</span>
									</div> */}
									{/* {props.session?.user?.loginData?.employeeMobileList?.length > 0 &&
										<div className={styles['rep-number']}>
										<i className='icon-HDRcall'></i>
										<span>{props.session.user.loginData.employeeMobileList[0]}</span>
									</div>} */}
									{/* {props.session?.user?.loginData?.employeeEmailList?.length > 0 &&
										<div className={styles['rep-mail']}>
											<i className='icon-mailLg'></i>
											<span>{props.session.user.loginData.employeeEmailList[0]}</span>
										</div>
									} */}
								</div>}

							</div>
							{props.tabKey == 'auditPending' || CreApprovalShowInfo ? null : <div className='cross-icon'>
								<i className='icon-HDRcross' onClick={closeInfoBox}></i>
							</div>}
						</> : <TabInfo infoText={infoText} isSubtext={true}/>  }
						</div>
					) : null}

					{!props.session.isReadOnly && props.tabKey != 'documentPending' && (ownerPendingComps && products.length && (props.tabKey != 'auditPending')) ? (
						<div className='select-all-div' onClick={(e) => { checkAll(e) }}>
						   <AnimateOnHover>
								<div className='multi-select-checkbox'>
									{isAllChecked && <i className='icon-Checkmark'></i>}
								</div>
							</AnimateOnHover>
							<div className='sel-label'>Select All</div>
						</div>
					) : null}
					{((!productShimmer && props.tabKey && !products.length && props.tabKey !== 'brochure' && !listDataFetching && !isFilterApplied && !props.session?.viaOmni) 
						|| (props?.user?.loggedUser?.userType == "AUDITOR" && !products.length && !productShimmer)
					) ? (
						<NoProductFound
							label={noProductLabel}
						/>
					) : null}
					{((props.tabKey == 'objectionable' && products.length && !isAuditor)) || props.tabKey == 'productConflict' ? (
						<ObjectionalNotify tabKey={props.tabKey} profileObject={props.session.profileObject}  />
					) : null}
					{/* {(!props.tabKey && products.length && !isAuditor && props.listing.isIneligibleDocid && showMaskProductsInfo) ? (
						MaskProductsInfo
					) : null} */}
					{productShimmer || props.listing.showShimmer ? (
						<>
							{Array(4).fill(1).map((cur) => {
								return (
									<div className='shimmer-container prod-block shimmer-holder'>
										<div className='img-holder shimmer-loader' />
										<div className='prod-desc'>
											<p className='prod-title shimmer-loader' />
											<p className='min-order-qty shimmer-loader' />
											<div className='price shimmer-loader' />
										</div>
										<div className='fake-border' />
									</div>
								)
							})}
						</>
					) : <>
						{
							vendorActiveTab == 2 ? <div className={styles["info-message"]}>
								<i class="icon-Info" />
								{`We have identified objectionable content in the following ${props?.session?.profileObject?.PluralLabelWithSpace.toLowerCase()}' details. They will go live only post moderation by the audit team.`}
							</div> : null
						}
						{(() => {
							switch(true){
								case !noProductPresent:{
									switch(props.tabKey){
										case 'brochure': 
											return <BrochureListing isContractor={isContractor} />;

										case 'inventoryCompliance': 
											return (<div>
											<InventoryComplianceList props={props} products={props.allProducts} allProducts={products || []} />
													</div> )

										default:
												return <ProductList
												{...props}
												products={vendorActiveTab == 2 ? props.objectionableProducts : products}
												objectionableMode={vendorActiveTab == 2}
												topPosClass={topPosClass}
												animateDirection={animateDirection}
												slideAgain={slideAgain}
												ref={prodListRef}
												sliderCloseCB={sliderCloseCB}
												confirmDelete={confirmDelete}
												isAuditor={isAuditor}
												bottomLoader={bottomLoader}
												isSpecialContract={showSearchAdd}
												toggleRequestTakeLive = {toggleRequestTakeLive}
												toggleActivateDeactivateModal = {toggleActivateDeactivateModalCB}
												updateObjectionModal={updateObjectionModal}
												ignoreLinkSlider={props.searchResult.length}
											/>
											
									}
								}
								default:
									return null;
							}
						})()}
					</>}
				<CSSTransition>
					{
					(!productShimmer && noProductPresent && noResultDataObj!=null && (
						<>
							<div
								className={`${styles['no-result-container']} ${noResultStyle['no-result-container']} ${noResultDataObj.className}`}
							>
								<img
									src={noResultDataObj.imgSrc}
									alt=""
									className={noResultStyle['no-result-img']}
								/>
								<h3 className={noResultStyle['no-result-heading']}>
									{noResultDataObj.title}
								</h3>
								{noResultDataObj.subTitle ? <h4
									className={
										noResultStyle['no-result-subheading']
									}
								>
									{noResultDataObj.subTitle}
								</h4> : ''}
								{noResultDataObj.button ? (
									<Button
										size='lg'
										clickHandler={clickHandler}
										className={noProductResult.button.className}
									>
										{noResultDataObj.button.showPlusIcon ? (
											<i className='icon-plus icon' />
										) : null}
										{noResultDataObj.button.text}
									</Button>
								) : null}
							</div>
							{
								!isAuditor ?
									<>
										<LinkUploadSlider
											source={props.session.source}
											tabKey={props.tabKey}
										/>
									</> : null
							}
						</>
					))
					}
				</CSSTransition>
				</>
			</CSSTransition>
				{
					showLoginBtn  ? (
						<div className={styles['login-btn-holder']}>
							<Button
								className={styles['full-width-login-btn']}
								clickHandler={() => {
									// history.push('/products/auth');
									checkLoggedIn({history});
								}}
							>
								{'Login'}
							</Button>
						</div>): null
				}
				{(props.session.showCompanyDetails ? props.session.user.loggedUser || (!props.session.viaOmni && !products.length) : true) && (!noProductPresent || isFilterApplied) && ((!props.tabKey || props.tabKey == 'brand') && !props.deletionPendingList.length) && !isAuditor || showSearchAdd ?(
					<AuthWrapper>
						{!isAuditor ? <AddPhotoProdButton
							redirectToAddProduct={redirectToAddProduct}
							tabKey={props.tabKey}
							openBulkUploadSlider={(value) => {
								if(props.isMobile) {
									history.push('/bulk-upload')
								} else {
									setBulkUpload(value)
								}
							}}
							redirectToJdPhotos={redirectToJdPhotos}
							redirectToBrandsCatSlider={redirectToBrandsCatSlider}
							productShimmer={productShimmer}
						/> : (
							(isAuditor && (props.tabKey == 'objectionable' || searchByDocId)) ? null : (
								<AnimateButton
								btnText='Add Product'
								iconClass="icon-plus"
								onClick={()=>{redirectToAddProduct()}}
								btnWidth='9.125rem'
								buttonClass = {styles['animate-button-add']}
							/>
							)
						)}
					</AuthWrapper>
				) : null}
				{props.showLibrarySlider && (
					<VideoListing />
				)}
			{props.tabKey == 'brand' && (props.brandSelDesel.showActive || props.brandSelDesel.showDeactive) && (isOwner || isJdRep) ? <>
					<ButtonGroup className={styles['brand-btn-holder']}>
						{ props.brandSelDesel.showActive && props.brandSelDesel.showDeactive ? <Button raised={true} variant="default" size="lg" className={`${styles['brand-btn']} ${styles['brand-btn-forward']}`} clickHandler={() => {
							upBrandProdStatus({action: 'deactivate'});
						}}>{`Deactivate`} <div className={'brand-btn-seperator'}> | </div></Button> : null}
						<Button raised={true} variant="default" size="lg" className={styles['brand-btn-reverse']} clickHandler={() => {
							const data = {action:'activate'};
							if(props.brandSelDesel.showDeactive && !props.brandSelDesel.showActive) {
								data.action = 'deactivate';
							}
							upBrandProdStatus(data);
						}}>{ (props.brandSelDesel.showDeactive && !props.brandSelDesel.showActive) ? `Deactivate`:`Activate` }</Button>
					</ButtonGroup>
					<div className={styles['brand-btn-fake-div']}></div>
			</> : null}
			{props.tabKey == 'approvalPending' && props.approvalPendingList.length && isOwner ? (

				props.isMobile ?
				<>
				<FullWidthButton
					className={`${styles['approve-btn']} ${props.session.hasGlassFooter ? styles['ubl-btm80'] : ''}`}
					clickHandler={() =>confirmApprove()}>
					<FullWidthButton.Section
						variant='left'
						text={`${(isAllChecked && props.tabKey == 'approvalPending') ? props?.listing?.approvalPendingCount : props.approvalPendingList.length} ${profileType}s`}
						subText='SELECTED'
					/>
					<FullWidthButton.Section iconClass='icon-hdrBackNew' variant='right' text={(props.approvalPendingList.length > 1 )? `Approve ${profileType}s` : `Approve ${profileType}`} />
				</FullWidthButton>
				<div aria-hidden="true" style={{ width: '100%', height: (props.session.hasGlassFooter ? 138 + endNudge : 58) + 'px' }}></div>
				</>
				:
				<>{!props.session.isReadOnly &&
				<div className={'approve-btn-holder'}>
					<Button className={styles['approve-btn']} clickHandler={() => confirmApprove()}>{(props.approvalPendingList.length > 1 )? `Approve ${profileType}s` : `Approve ${profileType}`}</Button>
				</div>

				}</>
			) : (!props.session.isReadOnly && props.tabKey == 'deletionPending' && props.deletionPendingList.length && isOwner ? (
				<>
					<ButtonGroup className={styles['delete-btn-holder']}>
						<Button raised={true} variant="default" size="lg" className={`${styles['delete-btn']} ${styles['delete-btn-forward']}`} clickHandler={() => updateProductStatus('delete', false)}>Don't Delete <div className={'delete-btn-seperator'}> | </div></Button>
						<Button raised={true} variant="default" size="lg" className={styles['delete-btn-reverse']} clickHandler={() => updateProductStatus('delete', true)}>Delete {profileType}{props.deletionPendingList.length > 1 ? 's' : ''}</Button>
					</ButtonGroup>
					<div className={styles['delete-btn-fake-div']}></div>
				</>
			) : ( showDeleteBtn ? (
				<AuthWrapper>
					<div className={`${styles['delete-btn-holder']} ${props.session.hasGlassFooter ? styles['ubl-btm80'] : ''}`}>
						<Button
							className={props.isMobile ? styles['full-width-delete-btn'] : styles['delete-btn-web']}
							clickHandler={() => updateProductStatus('delete', true)}
						>
							{
								(()=>{
									const isMany=props.deletionPendingList.length > 1 || (props.auditPendingList.length + props.objectionalAuditPendingList.length) > 1 || props.rejectedList.length > 1
									return isMany?`Delete ${props?.session?.profileObject?.PluralLabelWithSpace}` : `Delete ${props?.session?.profileObject?.SingleLabelWithSpace}`
								})()
							}
						</Button>
					</div>
					{/* Spacer also applies on Android / mobile web (not just iOS): base
						height 58px matches the Approve/Deletion fake-divs and keeps the last
						product from hiding behind the fixed Delete button. iOS adds the 80px
						glass-footer offset (=138) plus +endNudge for the re-settle nudge. */}
					{props.isMobile ? (
						<div aria-hidden="true" style={{ width: '100%', height: (props.session.hasGlassFooter ? 138 + endNudge : 58) + 'px' }}></div>
					) : null}
				</AuthWrapper>
			) : null))}
			{props.confirmDeleteModal && !props.isSearchSliderOpen ? <ConfirmDelete
				productData={productData || {}}
				serviceProfile={Number(props.session.newProfile) == 3}
				onDelete={deleteProduct}
				onModalClose={onDeleteModalClose}
				productsLength={props.deletionPendingList.length || (props.auditPendingList.length + props.objectionalAuditPendingList.length) || props.rejectedList.length}
				isMultiSelect={isMultiSelect}
				isGalleryProd={productData && productData.productName && productData.productName.indexOf('GPB2BMARKETPLACE') > -1}
			/> : null}
			{props.confirmApproveModal && !props.isSearchSliderOpen ? <ApproveProdModal
				productData={props.allProducts[props.approvalPendingList[0]]}
				onApprove={checkForCommission}
				serviceProfile={Number(props.session.newProfile) == 3}
				onModalClose={onApproveClose}
				productsLength={props.approvalPendingList.length}
				approvalPendingCount={props.listing.approvalPendingCount}
				isMultiSelect={props.approvalPendingList.length > 1 ? true : false}
				isAllSelected={isAllChecked}
			/> : null}
			{brandConfirmModal && !props.isSearchSliderOpen ? <ConfirmModal
				productData={brandConfirmModal.productData || {}}
				isDeactivate={brandConfirmModal.isDeactivate}
				onModalClose={() => {
					updateBrandModal(null);
				}}
				productsLength={brandConfirmModal.productsLength}
				isMultiSelect={brandConfirmModal.isMultiSelect}
				extraData={brandConfirmModal.extraData}
			/> : null}
			{showRepModal ? <Modal
				onHidden={() => {
					toggleRepModal(false);
				}}
				settings={{ variant: 'action ' + styles['rep-modal'] }}
			>
				<Modal.Body className='rep-modal'>
					<div className='rep-modal-text'><p>{`You have logged in as a ${props.session?.user?.loggedUser?.subType == 'ONBOARDREP' ? 'Onboarding Executive' : 'Justdial representative'} in vendor's digital catalogue.`}</p><p>Any changes you make in digital catalogue will need to be approved by the vendor before it goes live.</p></div>
					<Button clickHandler={() => {
						window.history.back();
					}}>Okay, Got It</Button>
				</Modal.Body>
			</Modal>
				: ''
			}
			{false && showVendorModal ? <Modal
				onHidden={() => {
					toggleVendorModal(false);
				}}
				settings={{ variant: 'action ' + styles['rep-modal'] }}
			>
				<Modal.Body className='vendor-modal'>
					<div className='vendor-modal-text'>Justdial representative has made some changes in your digital catalog which require your approval to go live</div>
					<Button clickHandler={() => {
						window.history.back();
					}}>Okay, Got It</Button>
				</Modal.Body>
			</Modal>
				: ''
			}
			{showViewDetails ? <Modal
				onHidden={() => {
					onViewClickModal(false)
				}}
				settings={{ variant: 'action ' + 'view-details-modal' ,
				class : 'website-modal'
				}}
			>
				<Modal.CloseIcon iconClass = {auditStyles['jd-cat-icon'] + ' icon-HDRcross'} />
				<Modal.Body className='view-modal-body'>
				<div className={auditStyles['header-holder']}>
            		<div className={auditStyles['user-text-profile']}>
						<JdRepresentativeProfile
							session={props.session}
							auditBtnArray = {AuditBtnArray}
							showToastMessage = {props.showToastMessage}
							dontShowViewButton = {true}
							AuditWebsiteBtn={AuditWebsiteBtn}
							fromListingPage = {true}
							contractorSourceList = {contractorSourceList}
                    		isShowConnectedNumberButton={false}
						/>
					</div>
				</div>
				</Modal.Body>
			</Modal>
				: ''

			}
			{showRequestTakeLive ? (
					<Modal
						settings= {{
							modalId: 'RequestTakeLive',
							variant: 'action',
							class: styles['request-take-live-modal']
						}}
						onHidden={() => toggleRequestTakeLive(false)}
					>
						<Modal.CloseIcon iconClass = {styles['modal-cross'] + ' icon-HDRcross'} />
						<Modal.Header>
							Request Submitted
						</Modal.Header>
						<div className = {styles['request-product-body']}>
							{`We have identified objectionable content in this ${props?.session?.profileObject?.SingleLabelWithSpace.toLowerCase()} details. It will go live only post moderation by the audit team.`}
						</div>
						<div className={styles['request-product-btn-holder']}>
							<Button
								size="lg"
								block
								clickHandler={() => {
									window.history.back();
								}}
							>
								{"Okay,Got it"}
							</Button>
						</div>
					</Modal>
				) : null}
			{justdialCatModal ? <JustdialCatModal
			showJDCatModal = {showJDCatModal}
			jdCatList={jdCatList}
			/> : null}
			{activateDeactivateModal.action ? (
					<Modal
						settings= {{
							modalId: 'activateDeactivate',
							variant: 'action',
							class: styles['activate-deactivate']
						}}
						onHidden={() => {
							toggleActivateDeactivateModal({});
							if(props.isMobile){
								detatchClasses();
							}
						}}
					>
						<Modal.CloseIcon iconClass = {styles['modal-cross'] + ' icon-HDRcross'} />
						<Modal.Header>
							{(activateDeactivateModal.action == "activate" ? "Activate" : "Deactivate") + " Product"}
						</Modal.Header>
						<div className = {styles['activate-deactivate-body']}>
							Are you sure you want to {(activateDeactivateModal.action == "activate" ? "activate" : "deactivate") + " "}<span className = {styles['activate-deactivate-name']}>{activateDeactivateModal.productData.productName}</span>{"?"}
						</div>
						<div className={styles['activate-deactivate-btn-holder']}>
							<Button
								size="lg"
								className={(activateDeactivateModal.action == "activate" ? "activate-btn" : "deactivate-btn")}
								block
								clickHandler={() => {
									let prodData = {...activateDeactivateModal.productData};
									if(activateDeactivateModal.action == "activate"){
										prodData.active = 1;
									}else{
										prodData.active = 0;
									}
									props.updateBrandedProduct({
										productData : prodData,
										cb : () => {
											window.history.back();
											let msg = `Product ${(activateDeactivateModal.action == "activate") ? "Activated" : "Deactivated"} Successfully`;
											const tempData = {...props.brandSelDesel};
											if(tempData.list[prodData.variantId]) {
												delete tempData.list[prodData.variantId];
												props.updateBrand({
													brandList: tempData
												});
											}
											dispatch(toastMessageActions.showMessage({
												message: msg,
												showReduxToast: true,
												animationTime :5000,
												bottom: props.session.hasGlassFooter ? '80px' : '0px',
											}))
										}
									});
								}}
							>
								{(activateDeactivateModal.action == "activate" ? "Activate" : "Deactivate") + " Product"}
							</Button>
						</div>
					</Modal>
				) : null}
				{commissionModal && <CommissionModal
				fromListing={true}
				onHidden={()=>{
					showCommissionModal(false)
				}}
				onSave={()=>{
					updateProductStatus();
					window.history.back();
				}}
				commissionRate={props.approvalPendingList.length == 1 ? props.allProducts[props.approvalPendingList[0]].commissionPerc : ''}
			/>}
			{showApprovalLinkModal ?
				<ActionModal
					onHidden={handleCloseModal}
					title={'Send Catalogue Approval Link'}
					content={<>Are you sure you want to send the catalogue approval link to the owner?</>}
					btnName= {'Send Link'}
					variant={'primary'}
					onclick={onConfirmApprovalLink}
				/>
				: null
			}
			{!props.isMobile && showBulkUpload && (
				<BulkUploadSlider
					onHidden={() => setBulkUpload(false)}
					updateBulkStatus={updateBulkStatus}
				/>
			)}
			{props.showProdConflict?
				<ProductConflictSlider barCodeConflictId={props.conflictProdKey} onHidden={() => {
					props.toggleProdConflict();
					props.getListingData({tabKey: 'productConflict'});
				}} />
				:null
			}
			{props.showCatCoverSlider || openCovSlider ?
				<JdCategoryCover
					redirectToAddProduct= {redirectToAddProduct}
					onHidden={handleShowJdCatCover}
				/>
				: null
			}
			{showAuditQueue ? (
				<RemoveAuditQueueSlider
					onHidden={() => toggleAuditQueueSlider(false)}
				/>
			) : null}
			{openBrandCatSlider && <EditBrandsSlider onHidden={() => updateBrandCatSlider(false)} />}
			{objectionModal.show ? <ObjectionContentModal apiData={objectionModal.apiData} onHidden={() => {objectionModal.cb && objectionModal.cb(objectionModal.isLastProductApproved); updateObjectionModal({show: false,apiData: null,cb: null})}}/> : null}
			{!isAuditor ? <UploadOptions /> : null}
		</div>
	);
};

const mapStateToProps = state => {
	return {
		listing:state.products.listing,
		session: state.session,
		filterProductObj: state.products.filterProductObj,
		tabKey:state.products.tabKey,
		isMobile:state.library.deviceData.isMobile,
		showLibrarySlider: state.videoLibrary.showLibrarySlider,
		approvalPendingList: state.products.approvalPendingList,
		auditPendingList: state.products.auditPendingList,
		objectionalAuditPendingList: state.products.objectionalAuditPendingList,
		rejectedList: state.products.rejectedList,
		deletionPendingList: state.products.deletionPendingList,
		objectionableList: state.products.objectionableList,
		brandList: state.products.brandList,
		brandSelDesel: state.products.brandSelDesel,
		allProducts: state.products.allProducts,
		confirmDeleteModal: state.products.confirmDeleteModal,
		confirmApproveModal: state.products.confirmApproveModal,
		isToggleTab: state.products.isToggleTab,
		showInfoBox: state.products.showInfoBox,
		isSearchSliderOpen: state.products.isSearchSliderOpen,
		redirectedFrom: state.products.redirectedFrom,
		objectionableProducts: state.products.vendorObjectionableProducts,
		selectedOutlet: (state.userSettings && state.userSettings.staticData) ? state.userSettings.staticData.selectedOutletId : '',
		genericDeletionList: state.products.genericDeletionList,
		user: state.session.user,
		showProdConflict: state.products.showProdConflict,
		showCatCoverSlider: state.jdCategoryList.showCatCoverSlider,
		conflictProdKey: state.products.conflictProdKey,
		shouldRetain: state.products.shouldRetain,
		brochureAttachment: state.products.brochureAttachment,
		pauseApprovalRedirect: state.products.pauseApprovalRedirect,
		searchResult: state.products.search.results,
		isUserApprovedForCatCoverage: state.session?.user?.isUserApprovedForCatCoverage
	};
};

export default connect(mapStateToProps, {
	getListingData,
	setCurrentEditPage,
	setTabStatus,
	getVendorProducts,
	updateApprovalPending,
	updateDeletionPending,
	updateProductStatus,
	deleteProduct,
	showToastMessage: toastMessageActions.showMessage,
	deleteProductFromList,
	toggleConfirmDelete,
	toggleConfirmApprove,
	toggleTab,
	setRedirectedFrom,
	updateProductConflict,
	toggleProdConflict,
	setSession,
	toggleInfoBox,
	getProductData,
	setSelectedType,
	getVendorImages,
	togglePhotoSlider,
	updateObjectionalPending,
	updateBrandPending,
	getVendorObjectionableProducts,
	updateBrandedProduct,
	updateGenericDeletionPending,
	updateBrand,
	showItemSearchSlider,
	updateAuditPending,
	updateRejectedProducts,
	showHideLoader,
	setShouldRetainScroll,
	resetListingData,
	showHideJdCatCover,
	deleteObjectionableProduct,
	setPreviousTabIndex,
	setIsUserApprovedForCatCoverage
})(Listing);
